import { constantCase } from 'change-case';
import { ulid } from 'ulid';

// Although this is not a TS package, types are exported to support TS
// applications. Please keep the type signature of this function in sync with
// the types exposed in generateId.d.ts
const generateId = (key: string) => {
  if (typeof key === 'undefined') {
    throw new TypeError('LogWeasel generateID requires a key argument');
  }

  return `${ulid()}-${constantCase(key)}-JS`;
};

export default generateId;
